import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export const pageContentApi = createApi({
    reducerPath: 'pageContentApi',
    baseQuery: baseQuery,
    tagTypes: ['PageContent'],
    endpoints: (builder) => ({
        getPageContent: builder.query({
            query: ({ clientName, pageName }) => ({
                url: '/content/page_content',
                method: 'GET',
                params: { 'client_name': clientName, 'page_name': pageName }
            }),
            providesTags: ['PageContent'],
        }),
        updatePageContent: builder.mutation({
            query: ({ clientName, pageName, content }) => ({
                url: '/content/page_content',
                method: 'PUT',
                body: { 'client_name': clientName, 'page_name': pageName, 'content': content }
            }),
            invalidatesTags: ['PageContent'],
        }),
        getAvailablePages: builder.query({
            query: () => ({
                url: '/content/available_pages',
                method: 'GET',
            }),
        }),
        getAvailableContentTypes: builder.query({
            query: () => ({
                url: '/content/available_content_types',
                method: 'GET',
            }),
        }),
        getAvailableItems: builder.query({
            query: ({ contentType }) => ({
                url: `/content/available_items?content_type=${contentType}`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useGetPageContentQuery,
    useUpdatePageContentMutation,
    useGetAvailablePagesQuery,
    useGetAvailableContentTypesQuery,
    useGetAvailableItemsQuery,
} = pageContentApi;

export default pageContentApi.reducer;